import { Theme } from "@material-ui/core/styles";

// ----------------------------------------------------------------------

export default function Menu(theme: Theme) {
  return {
    MuiMenuItem: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            backgroundColor: theme.palette.primary.lighter,
            "&:hover": {
              backgroundColor: theme.palette.primary.lighter
            }
          }
        }
      }
    }
  };
}
